module.exports = __webpack_public_path__ + "img/Kc.e1f913ad.png";